import React, { FC, ReactElement } from 'react';
import sprite from '../assets/img/sprite-mono.svg';

interface IconProps {
  name: string;
}

const Icon: FC<IconProps> = ({ name }): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`ico ico-mono-${name}`}>
      <use href={`${sprite}#ico-mono-${name}`} />
    </svg>
  );
};

export default Icon;
